<div *ngIf="isLoading" class="overlay-new"></div>

<div class="service-header-wrapper">
	<h2 class="mat-heading">{{ 'print.collection-jobs.label' | translate }}</h2>
	<div class="service-header-buttons">
		<div class="acies-density-high acies-list-search-field">
			<mat-form-field>
				<input matInput (keyup)="applyFilter($event)" [placeholder]="'insights.administration.users.search' | translate" #input />
				<button mat-icon-button matPrefix>
					<mat-icon svgIcon="acies_search"></mat-icon>
				</button>
			</mat-form-field>
		</div>
		<header-sub-menu [favoriteItems]="favoriteItems"></header-sub-menu>
	</div>
</div>

<div class="print-collection-jobs-stats">
	<div class="print-collection-jobs-stat print-job-status--working">
		<span class="print-collection-jobs-stat-count">{{ statusCounts.Working }}</span>
		<span class="print-collection-jobs-stat-label">
			{{ 'print.collection-jobs.status.working' | translate }}
		</span>
	</div>
	<div class="print-collection-jobs-stat print-job-status--done">
		<span class="print-collection-jobs-stat-count">{{ statusCounts.Done }}</span>
		<span class="print-collection-jobs-stat-label">
			{{ 'print.collection-jobs.status.done' | translate }}
		</span>
	</div>
	<div class="print-collection-jobs-stat print-job-status--failed">
		<span class="print-collection-jobs-stat-count">{{ statusCounts.Failed }}</span>
		<span class="print-collection-jobs-stat-label">
			{{ 'print.collection-jobs.status.failed' | translate }}
		</span>
	</div>
</div>

<div class="table-wrapper">
	<table mat-table [dataSource]="dataSource" matSort (matSortChange)="onSort($event)" multiTemplateDataRows>
		<ng-container matColumnDef="expand">
			<th mat-header-cell *matHeaderCellDef></th>
			<td mat-cell *matCellDef="let element">
				<button mat-icon-button (click)="toggleRow(element); $event.stopPropagation()">
					<mat-icon svgIcon="acies_chevrondown" [class.expanded]="expandedRow === element"></mat-icon>
				</button>
			</td>
		</ng-container>

		<ng-container matColumnDef="createdAt">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>
				{{ 'print.collection-jobs.created-at' | translate }}
			</th>
			<td mat-cell *matCellDef="let element">
				{{ element.createdAt | date: 'd/M/yy, HH:mm' }}
			</td>
		</ng-container>

		<ng-container matColumnDef="printers">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>
				{{ 'print.collection-jobs.printers' | translate }}
			</th>
			<td mat-cell *matCellDef="let element">{{ element.printers }}</td>
		</ng-container>

		<ng-container matColumnDef="status">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>
				{{ 'print.collection-jobs.status.label' | translate }}
			</th>
			<td mat-cell *matCellDef="let element">
				<span class="print-job-status-chip" [ngClass]="rowStatusClass(element.status)">
					{{ 'print.collection-jobs.status.' + element.status.toLowerCase() | translate }}
				</span>
			</td>
		</ng-container>

		<ng-container matColumnDef="jobs">
			<th mat-header-cell *matHeaderCellDef>
				{{ 'print.collection-jobs.jobs-column' | translate }}
			</th>
			<td mat-cell *matCellDef="let element">
				<ng-container *ngFor="let part of element.jobParts; let last = last">
					<span [ngClass]="part.statusClass">{{ part.text }}</span>
					<span *ngIf="!last">·</span>
				</ng-container>
			</td>
		</ng-container>

		<ng-container matColumnDef="expandedDetail">
			<td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length">
				<div class="print-collection-job-detail" *ngIf="expandedRow === element">
					<table class="print-collection-job-detail-table">
						<tr class="print-collection-job-detail-header">
							<th>{{ 'print.collection-jobs.job-detail.printer' | translate }}</th>
							<th>{{ 'print.collection-jobs.status.label' | translate }}</th>
							<th>
								{{ 'print.collection-jobs.job-detail.template-or-urls' | translate }}
							</th>
							<th>{{ 'print.collection-jobs.job-detail.error' | translate }}</th>
						</tr>
						<tr *ngFor="let job of element.jobs">
							<td>{{ getPrinterLabel(job.printer) }}</td>
							<td>
								<span class="print-job-status-chip" [ngClass]="jobStatusClass(job.status)">
									{{ 'print.collection-jobs.job-status.' + job.status.toLowerCase() | translate }}
								</span>
							</td>
							<td>{{ getJobTemplateOrUrls(job) }}</td>
							<td class="print-collection-job-detail-error" [matTooltip]="job.errorMessage" [matTooltipDisabled]="!job.errorMessage">
								{{ truncateError(job.errorMessage) }}
							</td>
						</tr>
					</table>
				</div>
			</td>
		</ng-container>

		<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
		<tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="toggleRow(row)"></tr>
		<tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="print-collection-job-detail-row" [style.display]="expandedRow === row ? '' : 'none'"></tr>
	</table>
</div>

<mat-paginator [pageSizeOptions]="[10, 20, 50, 100, 200, 500]" [pageSize]="50" showFirstLastButtons></mat-paginator>
